import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateFields, validateField } from './../../../utilities/validation/validator';
import { regexPatterns } from './../../../utilities/validation/validationVariables';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import lodash from 'lodash';

export const getCities = createAsyncThunk('addressForm/getCities', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCities', []);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getStreets = createAsyncThunk('addressForm/getStreets', async (city, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getStreetsByCity', [city]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getZipCode = createAsyncThunk('addressForm/getZipCode', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getZipCode', [data.street, data.city, data.houseNum, (data.entry ? data.entry : 'no_entrance')]);

    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getFiberStatus = createAsyncThunk('addressForm/getFiberStatus', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const zipCodeResult = await ProviderManager.getProviderData('getZipCode', [data.street, data.city, data.houseNum, (data.entry ? data.entry : 'no_entrance')]);
    const zipCode = zipCodeResult.Body;

    const result = await ProviderManager.getProviderData('getFiberStatus', [data.city, data.street, data.houseNum, data.apartment]);
    result.Body.zipCode = zipCode;

    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {
  currentStep: '',
  infrastructure: {
    tashtitType: '',
    custStatus: '',
    assetMarketStatus: '',
    assetDateSalesTarget: '',
    gponBuildingType: '',
    distributionType: '',
    infrastructure: '',
    defaultHomeNum: '',
    defaultApartment: '',
  },
  fiberData: {
    apartments: [],
    entryList: [],
  },
  cities: [],
  streets: [],
  form: {
    //cities: [],
    //streets: [],
    isCityWithoutStreets: false,
    isHaveFiber: false,
    isGetFiberStatusSuccess: false,
    isNotFoundError: false,
    isSelectedStreet: false,
    isSelectedCity: false,
    city: '',
    cityName: '',
    street: '',
    streetName: '',
    streetGisSemel: '',
    home: '',
    apartment: '',
    enter: '',
    zipCode: '',
    valid: '',
    zipExist: '',
    errors: {},
    errorObj: '',
    isFromBack: false,
    isShowPopUp: false,
    firstTechnicianDate: '',
    rules: {
      home: {
        required: { value: true, error: 'יש לבחור מספר בית' },
        pattern: { value: regexPatterns.numbersRegex, error: 'ערך לא תקין' },
      },
      technicianHours: {
        required: { value: true, error: 'יש לבחור מספר דירה' },
      },
    },
  },
};

const addressFrmSlice = createSlice({
  name: 'addressForm',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    setHomeNum: {
      reducer(state, action) {
        if (action.payload.HomeNum) {
          state.defaultHomeNum = action.payload.HomeNum;
          state.defaultApartment = action.payload.Apartment;
        }
      },
    },
    clearAddress: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);
        form.streets = '';
        form.city = '';
        form.cityName = '';
        form.street = '';
        form.streetName = '';
        form.streetGisSemel = '';
        form.home = '';
        form.apartment = '';
        form.zipCode = '';
        form.valid = '';
        form.zipExist = '';
        form.isSelectedStreet = false;
        form.isSelectedCity = false;
        form.firstTechnicianDate;

        return { payload: form };
      },
    },

    setIsNotFoundError: {
      reducer(state, action) {
        state.form.isNotFoundError = action.payload.isNotFoundError;
      },
    },
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        const updatedForm = validateFields(form);

        if (updatedForm.isNotFoundError) {
          updatedForm.valid = false;
        }
        return { payload: updatedForm };
      },
    },
    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    clearAddressDetails: {
      reducer(state, action) {
        state.form.isSelectedStreet = false;
        state.form.home = '';
        state.form.streetName = '';
        state.form.street = '';
        state.form.streetGisSemel = '';
        state.form.apartment = '';
      },
    },
    fiberStatusSuccessClear: {
      reducer(state, action) {
        state.form.isGetFiberStatusSuccess = false;
      },
    },
    zipExistClear: {
      reducer(state, action) {
        state.form.zipExist = '';
      },
    },
    clearFiberData: {
      reducer(state, action) {
        state.fiberData.entryList = [];
        state.form.isGetFiberStatusSuccess = false;
        state.form.zipExist = '';
        state.form.zipCode = '';
        state.infrastructure.tashtitType = '';
        state.infrastructure.custStatus = '';
        state.infrastructure.assetMarketStatus = '';
        state.infrastructure.assetDateSalesTarget = '';
        state.infrastructure.gponBuildingType = '';
        state.infrastructure.distributionType = '';
        state.infrastructure.infrastructure = '';
        state.infrastructure.defaultHomeNum = '';
        state.infrastructure.defaultApartment = '';
      },
    },
    clearFiberStatusSuccess: {
      reducer(state, action) {
        state.form.isGetFiberStatusSuccess = false;
        state.form.zipExist = '';
      },
    },
    reportAnalytics: (state, action) => { },
    setIsFromBack: {
      reducer(state, action) {
        state.form.isFromBack = true;
      },
    },
    setIsShowPopUp: {
      reducer(state, action) {
        state.form.isShowPopUp = action.payload;
      },
    },
    setIsValid: {
      reducer(state, action) {
        state.form.valid = action.payload;
      },
    },
    setFirstTechnicianDate: {
      reducer(state, action) {
        state.form.firstTechnicianDate = action.payload;
      },
    },
    addressReportStep: {
      reducer(state, action) {
        state.currentStep = action.payload;
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload.form;

        if (action.payload.infrastructureItem != null) {
          state.infrastructure.tashtitType = action.payload.infrastructureItem.tashtitType;
          state.infrastructure.custStatus = action.payload.infrastructureItem.custStatus;
          state.infrastructure.assetMarketStatus = action.payload.infrastructureItem.assetMarketStatus;
          state.infrastructure.assetDateSalesTarget = action.payload.infrastructureItem.assetDateSalesTarget;
          state.infrastructure.gponBuildingType = action.payload.infrastructureItem.gponBuildingType;
          state.infrastructure.distributionType = action.payload.infrastructureItem.distributionType;
          state.infrastructure.infrastructure = action.payload.infrastructureItem.infrastructure;
        }
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);

        if (value !== '' && name == 'enter') {
          const fiberData = lodash.cloneDeep(payload.fiberData);
          const tempArr = fiberData.apartments;
          const filteredArr = tempArr.filter((x) => x.entry === value);

          if (fiberData.apartments != undefined && fiberData.apartments.length != 0) {
            const validate = validateField(form, name, value);
            return { payload: { form: validate, infrastructureItem: filteredArr[0] } };
          }
        }

        if (value !== '' && name == 'city' && payload.cities.length != 0) {
          const filteredCity = payload.cities.filter((x) => x.cityCode === value);

          if (filteredCity.length > 0) {
            form.cityName = filteredCity[0].cityName;
            form.isNotFoundError = false;
            form.isSelectedCity = true;
            if (!form.isFromBack) {
              form.home = '';
              form.isFromBack = false;
            }
            form.apartment = '';
          } else {
            form.cityName = '';
            form.isNotFoundError = false;
            form.isSelectedCity = false;
            form.home = '';
            form.cityName = '';
            form.city = '';
            form.apartment = '';
          }
        }

        if (value !== '' && name == 'street' && payload.streets.length != 0) {
          const filteredStreet = payload.streets.filter((x) => x.streetCode === value);
          if (filteredStreet.length > 0) {
            form.streetName = filteredStreet[0].streetName;
            form.isNotFoundError = false;
            form.isSelectedStreet = true;
          } else {
            form.streetName = '';
            form.street = '';
            form.streetGisSemel = '';
            form.isNotFoundError = false;
            form.isSelectedStreet = false;
          }
        }

        const validate = validateField(form, name, value);

        return { payload: { form: validate, fiberData: null } };
      },
    },
  },
  extraReducers: {
    [getCities.fulfilled]: (state, action) => {
      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      //state.form.cities = action.payload;
      state.cities = action.payload;
    },
    [getStreets.fulfilled]: (state, action) => {
      if (action.payload.length === undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (state.form.city != '' && action.payload.length == 0) {
        state.form.streetName = state.form.cityName;
        state.form.isCityWithoutStreets = true;

        if (state.form.isCityWithoutStreets) {
          state.form.isSelectedStreet = false;
          state.form.isSelectedCity = false;
          state.form.home = '0';
          state.form.street = '0';
          state.form.streetGisSemel = '0';
        } else {
          state.form.isSelectedStreet = true;
          state.form.isSelectedCity = true;
          if (!state.form.isFromBack) {
            state.form.home = '';
            state.form.isFromBack = false;
          }
          state.form.street = '';
        }
      } else {
        //state.form.streets = action.payload;
        state.streets = action.payload;
        state.form.isCityWithoutStreets = false;

        if (!state.form.isFromBack) {
          state.form.home = '';
          state.form.street = '';
          state.form.isFromBack = false;
        }
        if (state.defaultHomeNum != '' && state.defaultHomeNum != undefined) {
          state.form.home = state.defaultHomeNum;
          state.form.apartment = state.defaultApartment;
        }
      }
    },

    [getZipCode.fulfilled]: (state, action) => {
      if (action.payload === undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (action.payload !== undefined) {
        state.form.zipCode = action.payload;
        state.form.zipExist = true;
      }
    },

    [getFiberStatus.fulfilled]: (state, action) => {
      if (action.payload === undefined) {
        state.fiberData.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (action.payload !== undefined) {
        if (action.payload.errorCode) {
          state.fiberData.errorObj = { errorId: action.payload.errorCode, message: action.payload.returnCodeMessage };
        }

        if (action.payload.isSuccess) state.form.isGetFiberStatusSuccess = true;

        if (action.payload.entryList != undefined && action.payload.entryList.length > 1) {
          state.form.isSelectEntry = false;
        }
        else {
          state.form.isSelectEntry = true;
        }

        if (action.payload.entryList != undefined && action.payload.entryList.length > 0) {
          let temp = [];

          if (action.payload.entryList.length == 1) {
            state.form.enter = action.payload.entryList[0];
          } else {
            for (let i = 0; i < action.payload.entryList.length; i++) {
              temp.push({ key: action.payload.entryList[i], value: action.payload.entryList[i] });
            }
            state.fiberData.entryList = temp;
          }
        }

        if (action.payload.dataInfoList != undefined && action.payload.dataInfoList.length > 0) {
          const firstItem = action.payload.dataInfoList[0];
          state.infrastructure.tashtitType = firstItem.tashtitType;
          state.infrastructure.custStatus = firstItem.custStatus;
          state.infrastructure.assetMarketStatus = firstItem.assetMarketStatus;
          state.infrastructure.assetDateSalesTarget = firstItem.assetDateSalesTarget;
          state.infrastructure.gponBuildingType = firstItem.gponBuildingType;
          state.infrastructure.distributionType = firstItem.distributionType;
          state.infrastructure.infrastructure = firstItem.infrastructure;
          state.form.isHaveFiber = true;
          state.fiberData.apartments = action.payload.dataInfoList;
        }

        state.form.zipCode = action.payload.zipCode;
        state.form.zipExist = true;
      }
    },
  },
});

export const {
  changeHandler,
  validateHandler,
  clearAddress,
  initValidation,
  setIsNotFoundError,
  setHomeNum,
  resetBlock,
  setIsFromBack,
  setIsShowPopUp,
  setIsValid,
  clearFiberData,
  clearFiberStatusSuccess,
  reportAnalytics,
  fiberStatusSuccessClear,
  zipExistClear,
  clearAddressDetails,
  addressReportStep,
  setFirstTechnicianDate,
} = addressFrmSlice.actions;
export default addressFrmSlice.reducer;
